import { render, staticRenderFns } from "./HaulageRevenueDashboardPage.vue?vue&type=template&id=5e936b9d&scoped=true&"
import script from "./HaulageRevenueDashboardPage.vue?vue&type=script&lang=js&"
export * from "./HaulageRevenueDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./HaulageRevenueDashboardPage.vue?vue&type=style&index=0&id=5e936b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e936b9d",
  null
  
)

export default component.exports